import NotixLoggerService from "Services/logger";
import UserService from "Services/user";

interface IResponseError {
  status: string;
  error: string;
}

interface IParseErrorResponse {
  data: IResponseError;
}

const parseErrorResponse = async (response: Response): Promise<string> => {
  const responseError: Promise<IParseErrorResponse> = new Promise((resolve) =>
    response.json().then((data: IResponseError) => {
      resolve({
        data,
      });
    })
  );
  const result: IParseErrorResponse = await responseError;
  return result?.data?.status;
};

interface ICustomToken {
  apiToken: string;
  tokenType: string;
}

interface IFetchRequest {
  url: string;
  method: string;
  useToken?: boolean;
  body: any;
  controller?: any;
  customToken?: ICustomToken;
}

export const FetchRequest = (props: IFetchRequest) => {
  const { url, method, useToken = false, body, controller, customToken } = props;

  const user = UserService.get();

  const init = {
    method: method,
  };

  if (useToken) {
    // @ts-ignore
    init.headers = {
      Authorization: `${user.tokenType} ${user.apiToken}`,
    };
  }

  if (!useToken && customToken) {
    // @ts-ignore
    init.headers = {
      Authorization: `${customToken.tokenType} ${customToken.apiToken}`,
    };
  }

  if (method === "POST") {
    // @ts-ignore
    init.body = JSON.stringify(body);
  }

  if (controller) {
    // @ts-ignore
    init.signal = controller?.signal;
  }
  return fetch(url, init).then(async (response) => {
    if (!response.ok) {
      const info = await parseErrorResponse(response);
      const manualError = new Error(
        `HTTP status code: ${response.status}, url: ${url}, ${
          info ? "Message: " + info : ""
        }`
      );

      const body = {
        message: `HTTP status code: ${response.status}, url: ${url}`,
        name: url,
        stack: "",
        code: response.status.toString(),
      };

      // @ts-ignore
      NotixLoggerService.logError(body);
      throw manualError;
    }
    return response.json();
  });
};
